import React from 'react'
import styled from 'styled-components';

import { Text } from 'components';
import { useService } from 'service';
import { dbToDate } from 'utils/date';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
`;

const ContainerHtml = styled.div`
  width: 100%;
  font-size: 16px;
  line-height: 1.5;
  border: 1px solid ${({ theme }) => theme.palette.black.light};
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 16px;
`;

export const ThisHeader = () => {
  const [dataHeader, { loading }, fetchHeader] = useService(
    'get',
    `/header/60a5c413e3d43d1758697904`
  );

  const header = dataHeader?.success?.header;

  return (
    <Container>
      <Text size="18" bold>
        Titulo:
        <Text size="18"> {header?.title.pt}</Text>
      </Text>

      <Text size="18" bold>
        Sub-Titulo:
        <Text size="18"> {header?.subTitle.pt}</Text>
      </Text>

      <Text size="18" bold>
        Resumo:
      </Text>
      <ContainerHtml>
        <Text size="18">{header?.resume.pt}</Text>
      </ContainerHtml>

      <Text size="18" bold>
        Conteudo:
      </Text>
      <ContainerHtml dangerouslySetInnerHTML={{ __html: header?.content.pt }} />

      <Text size="18" bold>
        Data Inicio:
        <Text size="18"> {dbToDate(header?.dateStart)}</Text>
      </Text>

      <Text size="18" bold>
        Data Fim:
        <Text size="18"> {dbToDate(header?.dateFinish)}</Text>
      </Text>

      <Text size="18" bold>
        Imagem:
      </Text>
      <img width="400" src={header?.image} />
    </Container>
  );
};
